import { RankEffectiveBetRecordType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

export const rankEffectiveBetRecordTypeName: { [key in RankEffectiveBetRecordType]: TKeyType } = {
  [RankEffectiveBetRecordType.DEDUCT]: 'common.deduct',
  [RankEffectiveBetRecordType.REVOKE]: 'common.revoke'
}

export default rankEffectiveBetRecordTypeName
